"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_router_1 = require("react-router");
var with_update_url_1 = require("./with_update_url");
var change_sticky_item_region_1 = require("../change_sticky_item_region");
/**
 * DEPRECATED
 * Please use CoreLink instewad of FilterLink
 */
function FilterLink(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var anchor = props.anchor, params = props.params, updateUrl = props.updateUrl, onClick = props.onClick, trackInteraction = props.trackInteraction, handleClickCallback = props.handleClickCallback, linkProps = tslib_1.__rest(props, ["anchor", "params", "updateUrl", "onClick", "trackInteraction", "handleClickCallback"]);
    function handleClick(e) {
        onClick && onClick(e);
        if (props.handleClickCallback) {
            props.handleClickCallback(e, params.page);
        }
        if (props.trackInteraction) {
            props.trackInteraction(params.page);
        }
        if (props.params.item_region) {
            change_sticky_item_region_1.changeStickyItemRegion(props.params.item_region, e.target.href);
        }
    }
    function linkLocation(currentLocation) {
        return updateUrl(currentLocation, params, anchor);
    }
    return (React.createElement(react_router_1.Link, tslib_1.__assign({ onClick: handleClick }, linkProps, { to: linkLocation })));
}
exports.FilterLink = FilterLink;
exports.default = with_update_url_1.withUpdateURL(FilterLink);
//# sourceMappingURL=filter_link.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/filter_link.js
// module id = 2k7U
// module chunks = 0 1 2 3 4 9 10 14 20